import React from 'react'
import { graphql } from 'gatsby'
import Image from 'gatsby-image';
import Layout from '../components/layout'

const peopleTemplate = ({ data, pageContext }) => {
  const { lang } = pageContext
  return (
    <Layout
      title={ data.markdownRemark.frontmatter.name }
      description={ data.markdownRemark.frontmatter.position }
      lang={ lang }
    >
      <div className="container section">
        <div className="columns">
          <div className="col-4 col-tablet-3 col-mobile-2"></div>
          <div className="col-4 col-tablet-6 col-mobile-8"><Image fluid={ data.markdownRemark.frontmatter.image.childImageSharp.fluid } /></div>
          <div className="col-4 col-tablet-3 col-mobile-2"></div>
        </div>
      </div>
      <div className="container section">
        <p className="text-size-5 heading"><span className="text-weight-bold">{ data.markdownRemark.frontmatter.name }</span>, { data.markdownRemark.frontmatter.position }</p>
        <div className="people" dangerouslySetInnerHTML={ lang === 'ja' ? {__html: data.markdownRemark.frontmatter.intoroductionJa} : {__html: data.markdownRemark.frontmatter.intoroductionEn} }/>
      </div>
    </Layout>
  )
}

export default peopleTemplate

export const query = graphql`
  query($slug: String!) {
    markdownRemark(frontmatter: {
      type: {eq: "people"}
      slug: {eq: $slug}
    }) {
      html
      frontmatter {
        name
        position
        grade
        image {
          childImageSharp {
            fluid ( maxWidth: 1000, maxHeight: 1200 ) {
              ...GatsbyImageSharpFluid
            }
          }
        },
        intoroductionJa,
        intoroductionEn
      }
    }
  }
`